module.exports = __webpack_public_path__ + "static/aire-acondicionado-5518958d617099477a17372510fa5167.jpg";